/**
 * Domain Status Types - Persisted status values shared by backend services and dashboard
 *
 * SE Traceability:
 * - Use Cases: UC-012 (Support Chat Management), UC-013 (Supervisor Control)
 * - Requirements: REQ-051 (Multi-channel support), REQ-052 (Chat history)
 * - Function: F-030 - Support Chat Handler
 * - Function Requirements:
 *   - FR-030-001: Define data structures for chat sessions (Input)
 *   - FR-030-002: Define message types and status (Input)
 *   - FR-022-018: Archive orphaned iLoca bookings without deleting them (Processing)
 *
 * Interfaces:
 * - Used by: business-services, sync-service and frontend components
 */
export enum MessageStatus {
  SENT = 'sent',
  PENDING_APPROVAL = 'pending_approval',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  FAILED = 'failed',
  GENERATING = 'generating', // AI response is being generated
  SENDING = 'sending' // Backend send claim; approve, edit or own reply
}

export enum SessionStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  RESOLVED = 'resolved',
  ABANDONED = 'abandoned',
  ESCALATED = 'escalated'
}

export enum BookingStatus {
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  CHANGED = 'CHANGED',
  MODIFIED = 'MODIFIED', // Alias for CHANGED used by dashboard and sync services
  PENDING = 'PENDING',
  CHECKED_IN = 'CHECKED_IN',
  CHECKED_OUT = 'CHECKED_OUT',
  ARCHIVED_ORPHAN = 'ARCHIVED_ORPHAN'
}
